import Logoblu from '../logo_blu.png';
import { lito_schmertmann } from './SBT_comp.js';


export const openCPTReport = ({name,tipo,comm,loc,add,fad,parQC,prof,parfs,parrf,park,parocr,pardr,pares,paded,parg0,
                        parcu,parm,parphip,parLT,parLTdarimap,parautLT,unitup,unitdw,mlito,mlitoval,mtype,mname,mgam,mgams,mcu,mphi,mdr,mm}) => {

  // Crea i dati ordinati prima di passarli
  const combinedData = prof.map((p, index) => ({
    prof: p,
    qc: parQC[index],
    fs: parfs[index],
    rf: parrf[index],
    k: park[index],
    ocr: parocr[index],
    dr: pardr[index],
    res: pares[index],
    ded:paded[index],
    g0: parg0[index],
    cu: parcu[index],
    m: parm[index],
    phip: parphip[index],
    lt: parLT[index],
    valuelt:parLTdarimap[index],
    // stratigrafia
  })).sort((a, b) => b.prof - a.prof);

  // Genera array ordinati per ciascun parametro
  const profSorted = combinedData.map(d => d.prof);
  const qcSorted = combinedData.map(d => d.qc);
  const fsSorted = combinedData.map(d => d.fs);
  const rfSorted = combinedData.map(d => d.rf);
  const kSorted = combinedData.map(d => d.k);
  const ocrSorted = combinedData.map(d => d.ocr);
  const drSorted = combinedData.map(d => d.dr);
  const resSorted = combinedData.map(d => d.res);
  const dedSorted = combinedData.map(d => d.ded);
  const g0Sorted = combinedData.map(d => d.g0);
  const cuSorted = combinedData.map(d => d.cu);
  const mSorted = combinedData.map(d => d.m);
  const phipSorted = combinedData.map(d => d.phip);
  const ltSorted = combinedData.map(d => d.lt);
  const valltSorted = combinedData.map(d => d.valuelt);

  // stratigrafia
  const unitupSorted = unitup?.length ? [...unitup].reverse().map(Number) : [];
  const unitdwSorted = unitdw?.length ? [...unitdw].reverse().map(Number) : [];
  const mlitoSorted = mlito?.length ? [...mlito].reverse() : [];
  const mlitovalSorted = mlitoval?.length ? [...mlitoval].reverse() : [];
  const mgamSorted = mgam?.length ? [...mgam].reverse() : [];
  const mgamsSorted = mgams?.length ? [...mgams].reverse() : [];
  const mcuSorted = mcu?.length ? [...mcu].reverse() : [];
  const mphiSorted = mphi?.length ? [...mphi].reverse() : [];
  const mdrSorted = mdr?.length ? [...mdr].reverse() : [];
  const mmSorted = mm?.length ? [...mm].reverse() : [];

  const mtypeSorted = mtype?.length ? [...mtype].reverse() : [];
  const mnameSorted = mname?.length ? [...mname].reverse() : [];

  // valori generali
  const tipologiaVal = tipo;
  const nomeProvaVal = name;
  const committenteVal = comm;
  const luogoVal = loc;
  const indirizzoVal = add;
  const faldaVal = fad;
  const autLTVal = parautLT;

  const maxProf = Math.max(...profSorted);
  const minProf = Math.min(...profSorted);

  // Data e ora odierna
  const now = new Date();
  const dateStr = now.toLocaleDateString('it-IT');
  const timeStr = now.toLocaleTimeString('it-IT');

  // Apriamo una nuova finestra per il report
  const reportWindow = window.open('', '_blank', 'width=1200,height=750');


  const stratigraphyRows = unitupSorted
      .map((top, i) => ({
        top: Number(top),
        bottom: Number(unitdwSorted[i]),
        name: mnameSorted[i],
        type: mtypeSorted[i],
        gam: Number(mgamSorted[i]),
        gams: Number(mgamsSorted[i]),
        cu: Number(mcuSorted[i]),
        phi: Number(mphiSorted[i]),
        dr: Number(mdrSorted[i]),
        m: Number(mmSorted[i])
      }))

      // elimina strati 0-0
      .filter(d => d.bottom !== 0 || d.top !== 0)

      // rimuove duplicati
      .filter((d, i, arr) =>
        arr.findIndex(s => s.top === d.top && s.bottom === d.bottom) === i
      )

      // ordina dall'alto verso il basso
      .sort((a, b) => a.top - b.top)

      // genera tabella
      .map(d => `
    <tr>
      <td>${d.name}</td>
      <td>${d.top}</td>
      <td>${d.bottom}</td>
      <td>${d.type}</td>
      <td>${d.gam.toFixed(2)}</td>
      <td>${d.gams.toFixed(2)}</td>
      <td>${d.cu.toFixed(2)}</td>
      <td>${d.phi.toFixed(2)}</td>
      <td>${d.dr.toFixed(2)}</td>
      <td>${d.m.toFixed(2)}</td>
    </tr>
    `).join("");

  let paginaLitotecnica = '';
    if (mlitoSorted.length > 1) {
      paginaLitotecnica = `
      <!-- PAGINA 7 - Verticale -->
      <div class="page1">
        <div class="title-left">
            <h2>Valori medi unità litotecniche ${nomeProvaVal}</h2>
            <hr>
        </div>
        <table class="data-table small-table" style="margin-top: 40px; margin-bottom: 20px;">
          <thead>
            <tr>
              <th>Nome</th>
              <th>Tetto (m da p.c.)</th>
              <th>Letto (m da p.c.)</th>
              <th>Tipo</th>
              <th>γ (kN/m³)</th>
              <th>γs (kN/m³)</th>
              <th>Cu (kPa)</th>
              <th>&phi;&prime; (°)</th>
              <th>Dr (%)</th>
              <th>M (MPa)</th>
            </tr>
          </thead>
          <tbody>
            ${stratigraphyRows}
          </tbody>
        </table>
        <div class="didascalia">
          Tab1 - Parametri medi per unità litotecniche
        </div>
      </div>
      `;
    }

  reportWindow.document.write(`
    <!DOCTYPE html>
    <html>
      <head>
        <script src="https://cdn.plot.ly/plotly-2.27.1.min.js"></script>
        <style>
          * {
            box-sizing: border-box;
            margin: 0;
            padding: 0;
          }
          body {
            font-family: Arial, sans-serif;
            margin: 0;
            padding: 0;
            background: white;
          }

          /* Pulsanti a destra */
          .controls {
            position: fixed;
            top: 10px;
            right: 10px;
            z-index: 1000;
            display: flex;
            gap: 5px;
            background: rgba(255,255,255,0.9);
            padding: 5px;
            border-radius: 8px;
            box-shadow: 0 2px 10px rgba(0,0,0,0.1);
          }

          .print-btn {
            background: #12455b;
            color: white;
            border: none;
            width: 32px;
            height: 32px;
            border-radius: 5px;
            font-size: 16px;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          .print-btn:hover {
            background: #0d3445;
          }

          /* PAGINE - senza salti automatici */
          @page {
            size: A4;
            margin: 1.5cm;
          }

          /* Pagina 1 - Verticale */
          .page1 {
            page: A4;
            min-height: 100vh;
            position: relative;
            padding: 20px;
          }

          /* Pagina 2 - Orizzontale */
          .page2 {
              page: landscape;
              size: A4 landscape;
              position: relative;
              padding: 5px 0px;
              display: flex;
              flex-direction: column;

              width: 100%;
              box-sizing: border-box; /* evita che il padding allarghi il box */
            }

          .content-wrapper {
              display: flex;
              flex-direction: column;
              flex: 1;
            }

          @page landscape {
            size: A4 landscape;
            margin: 1.5cm;
          }

          /* Logo solo prima pagina */
          .logo {
            position: absolute;
            bottom: 20px;
            right: 20px;
            width: 33px;
            height: auto;
            opacity: 0.7;
          }

          .logo img {
            width: 100%;
            height: auto;
            display: block;
          }

          /* Pagina 1 - Stili */
          .header {
            text-align: center;
            margin-bottom: 20px;
          }

          .header h1 {
            font-size: 28px;
            color: #333;
            margin-bottom: 5px;
          }

          .header h2 {
            font-size: 20px;
            color: #666;
            font-weight: normal;
          }

          .delimiter {
            text-align: right;
            font-size: 12px;
            color: #666;
            margin-bottom: 20px;
            border-bottom: 1px solid #ccc;
            padding-bottom: 5px;
          }

          .data-table {
            width: 100%;
            border-collapse: collapse;
          }

          .data-table td {
            padding: 8px 12px;
            border: 1px solid #ddd;
          }

          .data-table td:first-child {
            font-weight: bold;
            background-color: #f5f5f5;
            width: 150px;
          }

          .data-table input {
            width: 100%;
            border: none;
            padding: 5px;
            font-size: 14px;
            background: transparent;
          }

          .data-table .readonly {
            background-color: #f9f9f9;
            color: #666;
            font-style: italic;
            padding: 5px;
          }

          /* Pagina 2 - Stili */
          .title-left {
            text-align: left;
            margin: 0 !important;
            padding-bottom: 10 !important;
          }

          .title-left h2 {
              font-size: 20px;
              color: #333;
              margin: 0 !important;
              padding: 0 !important;
              line-height: 1.5 !important;
            }

          .title-left hr {
              width: 40%;
               margin: 2px 0 2px 0 !important;  /* Spazio minimo */
               padding: 0 !important;
              border: 1px solid #12455b;
            }

          /* Container grafici */
          .charts-container {
              margin: 0 !important;
              padding-bottom: 10 !important;
              height: auto;
              min-height: 0;
              display: flex;
              flex-wrap: wrap;
              gap: 5px;  /* Riduci gap se necessario */
              justify-content: center;  /* centra orizzontalmente */
              align-items: center;
            }

          .chart-item {
            width: calc(50% - 5px);
            height: 350px;
            background: white;
            border: 1px solid #eee;
            border-radius: 4px;
            padding: 5px;
          }

          .chart-item .plot-container {
            width: 100%;
            height: 100%;
          }

          .didascalia {
              margin: 0 !important;
              padding: 0 !important;
              line-height: 1 !important;
              font-size: 11px;
              text-align: center; /* centra il testo */
           }

          .page-number {
              font-size: 8px;
              color: #666;
            }

          @media print {
            .controls {
              display: none;
            }
            body {
              margin: 0;
              padding: 0;
            }
            .page1, .page2 {
              box-shadow: none;
              padding: 0.5cm;
            }
            .chart-item {
              border: none;
              height: 380px;
            }
          }

          /* Titolo principale leggermente più piccolo */
            .h1bis {
              font-size: 18px; /* ridotto rispetto a h1 normale */
              margin-bottom: 0.3em;
              font-weight: bold;
            }

            /* Tabella con font più piccolo */
            .data-table.small-table {
              font-size: 12px;
              border-collapse: collapse;
              width: 100%;
            }

            /* Bordo e padding generale */
            .data-table.small-table th,
            .data-table.small-table td {
              padding: 6px 8px;
              border: 1px solid #ccc;
            }

            /* Riga intestazione grigia solo per i titoli */
            .data-table.small-table thead th {
              background-color: #e0e0e0;
              font-weight: bold;
              text-align: left;

            }
        </style>
      </head>
      <body>
        <!-- Pulsanti -->
        <div class="controls">
          <button class="print-btn" onclick="window.print()" title="Salva PDF">💾</button>
          <button class="print-btn" onclick="window.close()" title="Chiudi">✖</button>
          <button class="print-btn" onclick="resetEditableFields()" title="Reset Campi">↺</button>
        </div>

        <!-- PAGINA 1 - Verticale -->
        <div class="page1">
          <div class="delimiter">
            <span>V.E.S. - Virtual Earth Suite</span>
            <span>Sviluppato dal Dott. Geol. Umberto Grechi</span>
          </div>

          <div class="header">
            <h1>V.E.S.</h1>
            <h2>Elaborato grafico prova penetrometrica</h2>
          </div>

          <table class="data-table">
            <tr><td>Committente</td><td><input type="text" id="committente" value="${committenteVal}"></td></tr>
            <tr><td>Località</td><td><input type="text" id="localita" value="${luogoVal}"></td></tr>
            <tr><td>Via</td><td><input type="text" id="via" value="${indirizzoVal}"></td></tr>
            <tr><td>Nome prova</td><td><input type="text" id="nome" value="${nomeProvaVal}"></td></tr>
            <tr><td>Tipo prova</td><td><div class="readonly">${tipologiaVal}</div></td></tr>
            <tr><td>Falda m da p.c.</td><td><div class="readonly">${faldaVal}</div></td></tr>
            <tr><td>Data elaborazione</td><td><div class="readonly">${dateStr}</div></td></tr>
          </table>

          <div class="logo">
            <img src="${Logoblu}" alt="Logo">
          </div>
        </div>

        <!-- PAGINA 2 - Orizzontale parametri-->
        <div class="page2">
          <div class="content-wrapper" >
            <div class="title-left">
              <h2>Parametri prova penetrometrica ${nomeProvaVal}</h2>
              <hr>
            </div>

            <div class="charts-container" id="chartsContainer1" >
              <!-- I grafici verranno inseriti dinamicamente -->
            </div>

            <div class="didascalia">
              Fig1 - Plot profondità-variabile della prova penetrometrica elaborata
            </div>
          </div>
        </div>

        <!-- PAGINA 3 - Orizzontale parametri -->
        <div class="page2">
          <div class="content-wrapper" >
            <div class="title-left">
              <h2>Parametri prova penetrometrica ${nomeProvaVal}</h2>
              <hr>
            </div>

            <div class="charts-container" id="chartsContainer2" >
              <!-- I grafici verranno inseriti dinamicamente -->
            </div>

            <div class="didascalia">
              Fig2 - Plot profondità-variabile della prova penetrometrica elaborata
            </div>
          </div>
        </div>

        <!-- PAGINA 4 - Orizzontale parametri -->
        <div class="page2">
          <div class="content-wrapper" >
            <div class="title-left">
              <h2>Parametri prova penetrometrica ${nomeProvaVal}</h2>
              <hr>
            </div>

            <div class="charts-container" id="chartsContainer3" >
              <!-- I grafici verranno inseriti dinamicamente -->
            </div>

            <div class="didascalia">
              Fig3 - Plot profondità-variabile della prova penetrometrica elaborata
            </div>
          </div>
        </div>

        <!-- PAGINA 6 - Orizzontale parametri -->
        <div class="page2">
          <div class="content-wrapper" >
            <div class="title-left">
              <h2>Stratigrafia prova ${nomeProvaVal}</h2>
              <hr>
            </div>
            <!-- Contenitore flex orizzontale -->
            <div class="chart-legend-wrapper"
                 style="display:flex; justify-content:center; align-items:center; gap:20px; margin-bottom:25px;">
                <div id="sbt-zones-chart" style="width:120px; margin-right:70px;"></div>
                <div class="charts-container"
                     id="lito_cptm"
                     style="display:flex; justify-content:center; align-items:center;">
                </div>
                <!-- Condizione per utcptm - mostrato solo se mlitoSorted ha più di 1 elemento -->
                    ${mlitoSorted.length > 1 ? `
                    <div class="charts-container"
                         id="utcptm"
                         style="display:flex; justify-content:center; align-items:center;">
                    </div>
                    ` : ''}
                <div id="lithology-legend" style="align-self:flex-start;">
                    <h1 class="h1bis">Legenda</h1>
                    <div id="legend-items"
                         style="display:flex; flex-direction:column; gap:5px;"></div>
                </div>
            </div>
            <div class="didascalia">
                ${mlitoSorted.length > 1
                  ? (autLTVal === 0
                      ? 'Fig5 - A sinistra Classificazione stratigrafica secondo Schmertmann, a destra Classificazione stratigrafica unità litotecniche secondo Schmertmann'
                      : 'Fig5 - A sinistra classificazione stratigrafica secondo Begemann, a destra classificazione stratigrafica unità litotecniche secondo Begemann')
                  : (autLTVal === 0
                      ? 'Fig5 - Classificazione stratigrafica secondo Schmertmann'
                      : 'Fig5 - classificazione stratigrafica secondo Begemann')}
            </div>
          </div>
        </div>


        <!-- PAGINA 7 - Verticale -->
        ${paginaLitotecnica}

        <!-- PAGINA LEGGENDA - Verticale -->
        <div class="page1">
          <div class="delimiter">
            <span>V.E.S. - Virtual Earth Suite</span>
            <span>Sviluppato dal Dott. Geol. Umberto Grechi</span>
          </div>

          <div class="header">
            <h1 class="h1bis">Legenda parametri</h1>
          </div>
            <table class="data-table small-table">
              <thead>
                <tr>
                  <th>Variabile</th>
                  <th>Unità di misura</th>
                  <th>Descrizione</th>
                  <th>Tratto distintivo</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>qc</td>
                  <td>[MPa]</td>
                  <td>Resistenza alla punta</td>
                  <td>––––––</td>
                </tr>
                <tr>
                  <td>fs</td>
                  <td>[kPa]</td>
                  <td>Resistenza laterale</td>
                  <td>––––––</td>
                </tr>
                <tr>
                  <td>Rf</td>
                  <td>[%]</td>
                  <td>Rapporto di attrito</td>
                  <td>––––––</td>
                </tr>
                 <tr>
                  <td>K</td>
                  <td>[m/s]</td>
                  <td>Permeabilità</td>
                  <td>––––––</td>
                </tr>
                <tr>
                  <td>OCR</td>
                  <td>[-]</td>
                  <td>Grado di sovraconsolidazione</td>
                  <td>––––––</td>
                </tr>
                <tr>
                  <td>DR</td>
                  <td>[%]</td>
                  <td>Densità Relativa</td>
                  <td>––––––</td>
                </tr>
                <tr>
                  <td>Ey</td>
                  <td>[MPa]</td>
                  <td>Modulo di young</td>
                  <td>––––––</td>
                </tr>
                <tr>
                  <td>Eu</td>
                  <td>[MPa]</td>
                  <td>Modulo di deformazine non drenato</td>
                  <td>––––––</td>
                </tr>
                <tr>
                  <td>G0</td>
                  <td>[MPa]</td>
                  <td>Modulo di taglio</td>
                  <td>––––––</td>
                </tr>
                <tr>
                  <td>M</td>
                  <td>[MPa]</td>
                  <td>Modulo Edometrico</td>
                  <td>––––––</td>
                </tr>
                <tr>
                  <td>Cu</td>
                  <td>[kPa]</td>
                  <td>Coesione non drenata</td>
                  <td>––––––</td>
                </tr>
                <tr>
              </tbody>
              <tr>
                  <td>φ&prime;</td>
                  <td>[°]</td>
                  <td>Angolo di attrito efficace</td>
                  <td>––––––</td>
              </tr>
            </table>
          <div class="logo">
            <img src="${Logoblu}" alt="Logo">
          </div>
        </div>

        <script>
          // Qui va tutto il JS relativo alla pagina
          const pages = document.querySelectorAll('.page1, .page2'); // prende tutte le pagine
          pages.forEach((page, index) => {
            const pageNumberDiv = document.createElement('div');
            pageNumberDiv.className = 'page-number';
            pageNumberDiv.style.position = 'absolute';
            pageNumberDiv.style.bottom = '5px';
            pageNumberDiv.style.left = '10px';
            pageNumberDiv.style.fontSize = '9px';
            pageNumberDiv.style.color = '#666';
            pageNumberDiv.innerText = (index + 1) + " / " + pages.length;
            page.appendChild(pageNumberDiv);
          });

          // Data di stampa
          
        </script>

        <!-- NESSUN ALTRO DIVISORE - così finisce qui -->

        <script>
          const profSorted = ${JSON.stringify(profSorted)};
          const qcSorted = ${JSON.stringify(qcSorted)};
          const fsSorted = ${JSON.stringify(fsSorted)};

          const rfSorted = ${JSON.stringify(rfSorted)};
          const kSorted = ${JSON.stringify(kSorted)};
          const ocrSorted = ${JSON.stringify(ocrSorted)};
          const drSorted = ${JSON.stringify(drSorted)};
          const resSorted = ${JSON.stringify(resSorted)};
          const dedSorted = ${JSON.stringify(dedSorted)};
          const g0Sorted = ${JSON.stringify(g0Sorted)};
          const cuSorted = ${JSON.stringify(cuSorted)};
          const mSorted = ${JSON.stringify(mSorted)};
          const phipSorted = ${JSON.stringify(phipSorted)};

          const ltSorted = ${JSON.stringify(ltSorted)};
          const valltSorted = ${JSON.stringify(valltSorted)};
          const autLTVal = ${autLTVal};

          //stratigrafia // Nuove variabili stratigrafia
          const unitupSorted = ${JSON.stringify(unitupSorted)};
          const unitdwSorted = ${JSON.stringify(unitdwSorted)};
          const mlitoSorted = ${JSON.stringify(mlitoSorted)};
          const mlitovalSorted = ${JSON.stringify(mlitovalSorted)};
          const mgamSorted = ${JSON.stringify(mgamSorted)};
          const mcuSorted = ${JSON.stringify(mcuSorted)};
          const mphiSorted = ${JSON.stringify(mphiSorted)};
          const mdrSorted = ${JSON.stringify(mdrSorted)};
          const mmSorted = ${JSON.stringify(mmSorted)};
          const mtypeSorted = ${JSON.stringify(mtypeSorted)};
          const mnameSorted = ${JSON.stringify(mnameSorted)};

          const maxProf = ${maxProf};
          const minProf = ${minProf};

          const charts1 = [
            {
              id: 'qcChart',
              data: qcSorted,
              color: 'black',
              name: 'QC',
              xLabel: 'qc [MPa]'
            },
            {
              id: 'fsChart',
              data: fsSorted,
              color: 'black',
              name: 'FS',
              xLabel: 'fs [kPa]'
            },
            {
              id: 'frChart',
              data: rfSorted,
              color: 'black',
              name: 'RF',
              xLabel: 'Rf [%]'
            },
            {
              id: 'kChart',
              data: kSorted,
              color: 'black',
              name: 'k',
              xLabel: 'K [m/s]',
            }
          ];

          const charts2 = [

            {
              id: 'OCRChart2',
              data: ocrSorted,
              color: 'black',
              name: 'OCR',
              xLabel: 'OCR'
            },
            {
              id: 'drChart2',
              data: drSorted,
              color: 'black',
              name: 'DR',
              xLabel: 'DR [%]'
            },
            {
              id: 'esChart2',
              data: resSorted,
              color: 'black',
              name: 'Ey',
              xLabel: 'Ey [MPa]'
            },
            {
              id: 'dedChart2',
              data: dedSorted,
              color: 'black',
              name: 'Eu',
              xLabel: 'Eu [MPa]'
            },

          ];

          const charts3 = [
           {
              id: 'g0Chart2',
              data: g0Sorted,
              color: 'black',
              name: 'G0',
              xLabel: 'G0 [MPa]'
            },
          {
            id: 'mChart3',
            data: mSorted,
            color: 'black',
            name: 'M',
            xLabel: 'M [MPa]'
          },
           {
            id: 'cuChart3',
            data: cuSorted,
            color: 'black',
            name: 'Cu',
            xLabel: 'Cu [kPa]'
          },
          {
            id: 'phipChart3',
            data: phipSorted,
            color: 'black',
            name: "φ'",
            xLabel: "φ' [°]"
          },
          ];

          const CHART_WIDTH = 180;
          const CHART_HEIGHT = 570;
          // NUOVE dimensioni dedicate per SBT
          const LITO_CHART_WIDTH = 200;
          const LITO_CHART_HEIGHT = 520;

          let dict_plt; // dichiara prima

          if (autLTVal === 0) {
                dict_plt = {
                    'out of correlation':'lightgray',
                    'sabbie calcaree o marne':'darkgrey',
                    'sabbia addensata o cementata':'gold',
                    'sabbia':'orange',
                    'sabbia sciolta':'darkgoldenrod',
                    'sabbie argillose e limi':'goldenrod',
                    'limi e sabbie':'forestgreen',
                    'argille sabbiose e limose':'darkolivegreen',
                    'argilla inorganica molto compatta':'powderblue',
                    'argilla inorganica a media consistenza':'chocolate',
                    'argilla inorganica a bassa consistenza':'darkblue',
                    'argille organiche e terreni misti':'saddlebrown',
                };
          } else {
                dict_plt = {
                    'sabbia con ghiaia':'darkgrey',
                    'sabbia limosa':'darkgoldenrod',
                    'limo sabbioso argilloso':'forestgreen',
                    'miscela di argilla e limo':'darkolivegreen',
                    'argilla':'chocolate',
                    'terreno organico':'saddlebrown',
                    'out of correlation':'lightgray'
                };
            }

          window.resetEditableFields = function() {
            document.getElementById('committente').value = '';
            document.getElementById('localita').value = '';
            document.getElementById('via').value = '';
            document.getElementById('nome').value = '';
            localStorage.removeItem('cptReportData');
          };

          function loadSavedData() {
            const saved = localStorage.getItem('cptReportData');
            if (saved) {
              const data = JSON.parse(saved);
              document.getElementById('committente').value = data.committente || '';
              document.getElementById('localita').value = data.localita || '';
              document.getElementById('via').value = data.via || '';
              document.getElementById('nome').value = data.nome || '';
            }
          }

          function saveData() {
            const data = {
              committente: document.getElementById('committente').value,
              localita: document.getElementById('localita').value,
              via: document.getElementById('via').value,
              nome: document.getElementById('nome').value
            };
            localStorage.setItem('cptReportData', JSON.stringify(data));
          }

        function createCharts1() {
              const container1 = document.getElementById('chartsContainer1');
              if (!container1) return;

              container1.innerHTML = '';

              // Funzione per convertire i valori
              function parseValue(v) {
                if (v === null || v === undefined) return null;
                if (v === 0 || v === "0") return null; // nasconde gli zeri
                if (typeof v === "string" && v.startsWith(">")) {
                  return parseFloat(v.slice(1)) + 2; // >9 → 11
                }
                const num = parseFloat(v);
                return Number.isFinite(num) ? num : null;
              }

              // Crea i contenitori dei grafici
              charts1.forEach((chart) => {
                const chartDiv = document.createElement('div');
                chartDiv.className = 'chart-item';
                chartDiv.style.width = CHART_WIDTH + 'px';
                chartDiv.style.height = CHART_HEIGHT + 'px';

                const plotDiv = document.createElement('div');
                plotDiv.id = chart.id;
                plotDiv.className = 'plot-container';

                chartDiv.appendChild(plotDiv);
                container1.appendChild(chartDiv);
              });

              // Crea i grafici
              charts1.forEach((chart) => {
                const parsedData = chart.data.map(parseValue);
                const validData = parsedData.filter(v => v !== null);

                if (validData.length === 0) return;

                // Calcola min e max dei dati
                let minX, maxX;
                if (validData.length === 1) {
                  const v = validData[0];
                  minX = 0;
                  maxX = v * 1.1;
                } else {
                  minX = 0;
                  maxX = Math.max(...validData) * 1.1;
                }

                // Linea verticale di riferimento
                const xLimit = maxX;

                // Modalità: singolo valore → marker, più valori → line
                const modeType = validData.length === 1 ? 'markers' : 'lines';

                const traces = [{
                  x: parsedData,
                  y: profSorted,
                  type: 'scatter',
                  mode: modeType,
                  line: { color: chart.color, width: 1.5 },
                  marker: { size: 6, color: chart.color },
                  name: chart.name
                }];

                // Tickformat / asse X differente solo per kChart1
                let xAxisFormat = {};
                if (chart.id === 'kChart') {
                  xAxisFormat = {
                    title: { text: chart.xLabel, font: { family: 'Roboto, sans-serif', size: 9 } },
                    type: 'log',
                    showgrid: true,
                    gridcolor: '#888888',
                    griddash: 'dash',
                    tickfont: { family: 'Roboto, sans-serif', size: 8 },
                    linecolor: 'black',
                    linewidth: 1,
                    exponentformat: 'power',
                    autorange: true
                  };
                } else {
                  xAxisFormat = {
                    title: { text: chart.xLabel, font: { family: 'Roboto, sans-serif', size: 9 } },
                    range: [minX, maxX],
                    showgrid: true,
                    gridcolor: '#888888',
                    griddash: 'dash',
                    tickfont: { family: 'Roboto, sans-serif', size: 8 },
                    linecolor: 'black',
                    linewidth: 1,
                    autorange: false
                  };
                }

                Plotly.newPlot(chart.id, traces, {
                  width: CHART_WIDTH - 20,
                  height: CHART_HEIGHT - 20,
                  xaxis: xAxisFormat,
                  yaxis: {
                    title: { text: 'Profondità [m]', font: { family: 'Roboto, sans-serif', size: 9 } },
                    range: [maxProf, 0],
                    showgrid: true,
                    gridcolor: '#888888',
                    griddash: 'dash',
                    tickfont: { family: 'Roboto, sans-serif', size: 8 },
                    linecolor: 'black',
                    linewidth: 1,
                    dtick: 1,
                    autorange: false
                  },
                  margin: { t: 20, r: 20, l: 30, b: 30 },
                  shapes: [
                    {
                      type: 'line',
                      x0: xLimit,
                      x1: xLimit,
                      y0: 0,
                      y1: maxProf,
                      line: { color: 'black', width: 1 }
                    }
                  ],
                  showlegend: false
                });
              });
            }

        function createCharts2() {

              const container2 = document.getElementById('chartsContainer2');
              if (!container2) return;

              container2.innerHTML = '';

              // converte i valori
              function parseValue(v) {

                if (v === null || v === undefined) return null;

                // nasconde gli 0
                if (v === 0 || v === "0") return null;

                // gestisce valori tipo ">9"
                if (typeof v === "string" && v.startsWith(">")) {
                  return parseFloat(v.slice(1)) + 2; // >9 → 11
                }

                const num = parseFloat(v);

                return Number.isFinite(num) ? num : null;
              }

              // crea i contenitori dei grafici
              charts2.forEach((chart) => {

                const chartDiv = document.createElement('div');
                chartDiv.className = 'chart-item';
                chartDiv.style.width = CHART_WIDTH + 'px';
                chartDiv.style.height = CHART_HEIGHT + 'px';

                const plotDiv = document.createElement('div');
                plotDiv.id = chart.id;
                plotDiv.className = 'plot-container';

                chartDiv.appendChild(plotDiv);
                container2.appendChild(chartDiv);

              });

              // crea i grafici
              charts2.forEach((chart) => {

                const parsedData = chart.data.map(parseValue);
                const validData = parsedData.filter(v => v !== null);

                if (validData.length === 0) return;

                // calcola min e max dei dati
                let minX, maxX;
                if (validData.length === 1) {
                  const v = validData[0];
                  minX = 0;
                  maxX = v * 1.1;
                } else {
                  minX = 0;
                  maxX = Math.max(...validData) * 1.1;
                }

                // linea verticale: se DR → fisso a 100, altrimenti maxX
                const xLimit = maxX;

                // modalità: solo un punto → marker, più punti → linea
                const modeType = validData.length === 1 ? 'markers' : 'lines';

                const traces = [{
                  x: parsedData,
                  y: profSorted,
                  type: 'scatter',
                  mode: modeType,
                  line: { color: chart.color, width: 1.5 },
                  marker: { size: 3, color: chart.color },
                  name: chart.name
                }];

                Plotly.newPlot(chart.id, traces, {

                  width: CHART_WIDTH - 20,
                  height: CHART_HEIGHT - 20,

                  xaxis: {
                    title: { text: chart.xLabel, font: { family: 'Roboto, sans-serif', size: 9 } },
                    range: [minX, maxX],
                    showgrid: true,
                    gridcolor: '#888888',
                    griddash: 'dash',
                    tickfont: { family: 'Roboto, sans-serif', size: 8 },
                    linecolor: 'black',
                    linewidth: 1,
                    autorange: false
                  },

                  yaxis: {
                    title: { text: 'Profondità [m]', font: { family: 'Roboto, sans-serif', size: 9 } },
                    range: [maxProf, 0],
                    showgrid: true,
                    gridcolor: '#888888',
                    griddash: 'dash',
                    tickfont: { family: 'Roboto, sans-serif', size: 8 },
                    linecolor: 'black',
                    linewidth: 1,
                    dtick: 1,
                    autorange: false
                  },

                  margin: { t: 20, r: 20, l: 30, b: 30 },

                  shapes: [
                    {
                      type: 'line',
                      x0: xLimit,
                      x1: xLimit,
                      y0: 0,
                      y1: maxProf,
                      line: { color: 'black', width: 1 }
                    }
                  ],

                  showlegend: false

                });

              });

            }

        function createCharts3() {
              const container3 = document.getElementById('chartsContainer3');
              if (!container3) return;

              container3.innerHTML = '';

              // Funzione per convertire i valori
              function parseValue(v) {
                if (v === null || v === undefined) return null;
                if (v === 0 || v === "0") return null; // nasconde gli zeri
                if (typeof v === "string" && v.startsWith(">")) {
                  return parseFloat(v.slice(1)) + 2; // >9 → 11
                }
                const num = parseFloat(v);
                return Number.isFinite(num) ? num : null;
              }

              // Crea i contenitori dei grafici
              charts3.forEach((chart) => {
                const chartDiv = document.createElement('div');
                chartDiv.className = 'chart-item';
                chartDiv.style.width = CHART_WIDTH + 'px';
                chartDiv.style.height = CHART_HEIGHT + 'px';

                const plotDiv = document.createElement('div');
                plotDiv.id = chart.id;
                plotDiv.className = 'plot-container';

                chartDiv.appendChild(plotDiv);
                container3.appendChild(chartDiv);
              });

              // Crea i grafici
              charts3.forEach((chart) => {
                const parsedData = chart.data.map(parseValue);
                const validData = parsedData.filter(v => v !== null);

                if (validData.length === 0) return;

                // Calcola min e max dei dati
                let minX, maxX;
                if (validData.length === 1) {
                  const v = validData[0];
                  minX = 0;
                  maxX = v * 1.1;
                } else {
                  minX = 0;
                  maxX = Math.max(...validData) * 1.1;
                }

                // Linea verticale di riferimento
                const xLimit = maxX;

                // Modalità: singolo valore → marker, più valori → line
                const modeType = validData.length === 1 ? 'markers' : 'lines';

                const traces = [{
                  x: parsedData,
                  y: profSorted,
                  type: 'scatter',
                  mode: modeType,
                  line: { color: chart.color, width: 1.5 },
                  marker: { size: 3, color: chart.color },
                  name: chart.name
                }];

                Plotly.newPlot(chart.id, traces, {
                  width: CHART_WIDTH - 20,
                  height: CHART_HEIGHT - 20,
                  xaxis: {
                    title: { text: chart.xLabel, font: { family: 'Roboto, sans-serif', size: 9 } },
                    range: [minX, maxX],
                    showgrid: true,
                    gridcolor: '#888888',
                    griddash: 'dash',
                    tickfont: { family: 'Roboto, sans-serif', size: 8 },
                    linecolor: 'black',
                    linewidth: 1,
                    autorange: false
                  },
                  yaxis: {
                    title: { text: 'Profondità [m]', font: { family: 'Roboto, sans-serif', size: 9 } },
                    range: [maxProf, 0],
                    showgrid: true,
                    gridcolor: '#888888',
                    griddash: 'dash',
                    tickfont: { family: 'Roboto, sans-serif', size: 8 },
                    linecolor: 'black',
                    linewidth: 1,
                    dtick: 1,
                    autorange: false
                  },
                  margin: { t: 20, r: 20, l: 30, b: 30 },
                  shapes: [
                    {
                      type: 'line',
                      x0: xLimit,
                      x1: xLimit,
                      y0: 0,
                      y1: maxProf,
                      line: { color: 'black', width: 1 }
                    }
                  ],
                  showlegend: false
                });
              });
            }

          //Plot litologia
          //shmertmann
          function createLithologyPlot(containerId) {
            const container = document.getElementById(containerId);
            if (!container) return;

            container.innerHTML = '';

            const labels = Object.keys(dict_plt);

            // Prepara i dati per le tracce
            const traces = [];

            const ultimoSpessore = Math.abs(profSorted[profSorted.length - 1] - profSorted[profSorted.length - 2]);
            // Calcola il nuovo valore da aggiungere
            let nuovoValore = profSorted[profSorted.length - 1] - ultimoSpessore;
            // Se l'ultimo valore è già 0, mantieni 0 come limite superficiale
            if (profSorted[profSorted.length - 1] === 0) {
                nuovoValore = 0;
            }
            // Aggiungi il valore alla fine dell'array
            const profEsteso = [...profSorted, nuovoValore];

            for (let i = 0; i < profEsteso.length - 1; i++) {
                const top = profEsteso[i + 1]; // Il valore originale diventa il bottom
                const bottom = profEsteso[i];   // Il nuovo valore è il top
                let lt = ltSorted[i];
                let label = labels[lt];

                if (lt === 0) label = 'out of correlation';

                const color = dict_plt[label];
                let xEnd = valltSorted[i];
                if (lt === 0) xEnd = 0.5;
                // Altezza del rettangolo (spessore dello strato)
                const height = Math.abs(bottom - top);
                // Centro dello strato
                const centerY = (top + bottom) / 2;

                traces.push({
                    type: 'bar',
                    orientation: 'h',
                    y: [centerY],
                    x: [xEnd],
                    width: [height],
                    base: [0],
                    marker: {
                        color: color,
                        line: {
                            width: 0
                        }
                    },
                    hoverinfo: 'none',
                    showlegend: false,
                    xaxis: 'x',
                    yaxis: 'y'
                });
            }

            const layout = {
                width: LITO_CHART_WIDTH,
                height: LITO_CHART_HEIGHT,
                xaxis: {
                    title: {
                        text: 'Litologia',
                        font: { family: 'Roboto, sans-serif', size: 10 }
                    },
                    range: [0, 10],
                    tickmode: "array",
                    tickvals: [...Array(10).keys()],
                    ticktext: [...Array(10).keys()],
                    showgrid: false,
                    tickfont: { family: 'Roboto, sans-serif', size: 8 },
                    fixedrange: true
                },
                yaxis: {
                    title: {
                        text: 'Profondità [m]',
                        font: { family: 'Roboto, sans-serif', size: 10 }
                    },
                    range: [maxProf, 0],
                    autorange: false,
                    showgrid: false,
                    linewidth: 1,
                    dtick: 1,
                    tickfont: { family: 'Roboto, sans-serif', size: 8 },
                    fixedrange: true
                },
                margin: { t: 20, l: 30, r: 30, b: 30 },
                showlegend: false,
                barmode: 'overlay', // Sovrappone le barre
                bargap: 0, // Nessun gap tra barre
                bargroupgap: 0 // Nessun gap tra gruppi
            };

            Plotly.newPlot(containerId, traces, layout, {
                responsive: true,
                displayModeBar: false,
                staticPlot: true // Disabilita interattività per rendering più pulito
            });
        }

        //plot della litologia con elaborazione unità
        function createunitPlot(containerId) {
            const container = document.getElementById(containerId);
            if (!container) return;
            container.innerHTML = '';

            const labels = Object.keys(dict_plt);

            // Costruisci l’array dei confini tra strati
            const profCombined = [unitupSorted[0], ...unitdwSorted];

            // Prepara i dati per le tracce
            const traces = [];
            const annotations = [];

            for (let i = 0; i < unitupSorted.length; i++) {

                const top = Number(unitupSorted[i]);
                const bottom = Number(unitdwSorted[i]);
                const lt = Number(mlitoSorted[i]);

                let label = labels[lt];
                if (lt === 0) label = 'out of correlation';

                const color = dict_plt[label];

                const height = bottom - top;
                const centerY = top + height / 2;

                let xEnd = mlitovalSorted[i] === 0 ? 0.5 : mlitovalSorted[i];
                // posizione dinamica del testo
                let testoEtichetta = mnameSorted[i];
                console.log(testoEtichetta)

                // Crea l'annotazione SOLO se il testo non è vuoto o undefined
                if (testoEtichetta && testoEtichetta.trim() !== '') {
                    let xEnd = mlitovalSorted[i] === 0 ? 0.5 : mlitovalSorted[i];
                    // posizione dinamica del testo
                    let textX = xEnd < 1.5 ? 1 : xEnd / 2;

                    annotations.push({
                        x: textX,
                        y: centerY,
                        text: testoEtichetta,
                        showarrow: false,
                        font: { family: 'Roboto, sans-serif', size: 10, color: 'black' },
                        xanchor: 'center',
                        yanchor: 'middle',
                        bgcolor: 'white',
                        bordercolor: 'black',
                        borderwidth: 1,
                        borderpad: 2
                    });
                }

                traces.push({
                    type: 'bar',
                    orientation: 'h',
                    y: [centerY],
                    x: [xEnd],
                    width: [height],
                    base: [0],
                    marker: {
                        color: color,
                        line: { width: 0 }
                    },
                    hoverinfo: 'none',
                    showlegend: false
                });
            }

            const layout = {
                width: LITO_CHART_WIDTH,
                height: LITO_CHART_HEIGHT,
                xaxis: { title: { text: 'Litologia', font: { family: 'Roboto, sans-serif', size: 10 } },
                         range: [0, 10], tickmode: "array", tickvals: [...Array(10).keys()],
                         ticktext: [...Array(10).keys()], showgrid: false, tickfont: { family: 'Roboto, sans-serif', size: 8 }, fixedrange: true },
                yaxis: { title: { text: 'Profondità [m]', font: { family: 'Roboto, sans-serif', size: 10 } },
                         range: [Math.max(...profCombined), 0], autorange: false, showgrid: false, linewidth: 1, dtick: 1,
                         tickfont: { family: 'Roboto, sans-serif', size: 8 }, fixedrange: true },

                annotations: annotations,
                margin: { t: 20, l: 30, r: 30, b: 30 },
                showlegend: false,
                barmode: 'overlay',
                bargap: 0,
                bargroupgap: 0
            };

            Plotly.newPlot(containerId, traces, layout, { responsive: true, displayModeBar: false, staticPlot: true });
        }

        function createLithologyLegend(containerId, dict_plt) {
            const container = document.getElementById(containerId);
            if (!container) return;
            const legendDiv = container.querySelector('#legend-items');
            if (!legendDiv) return;
            legendDiv.innerHTML = ''; // pulisci

            const labels = Object.keys(dict_plt);

            labels.forEach((label, idx) => {
                const color = dict_plt[label];

                const item = document.createElement('div');
                item.style.display = 'flex';
                item.style.alignItems = 'center';
                item.style.gap = '5px';

                // Quadratino bianco con numero
                const numberBox = document.createElement('div');
                numberBox.textContent = idx;
                numberBox.style.width = '20px';
                numberBox.style.height = '20px';
                numberBox.style.backgroundColor = 'white';
                numberBox.style.border = '1px solid black';
                numberBox.style.display = 'flex';
                numberBox.style.alignItems = 'center';
                numberBox.style.justifyContent = 'center';
                numberBox.style.fontSize = '12px';
                numberBox.style.fontWeight = 'bold';

                // Quadratino colorato della litologia usando canvas
                const colorBox = document.createElement('canvas');
                colorBox.width = 20;
                colorBox.height = 20;
                colorBox.style.border = '1px solid black';
                const ctx = colorBox.getContext('2d');
                ctx.fillStyle = color;
                ctx.fillRect(0, 0, 20, 20);

                // Testo descrittivo
                const text = document.createElement('span');
                text.textContent = label;
                text.style.fontSize = '12px';
                text.style.flex = '1'; // occupa tutto lo spazio rimanente
                text.style.whiteSpace = 'nowrap'; // evita di andare a capo
                text.style.overflow = 'hidden';
                text.style.textOverflow = 'ellipsis';

                item.appendChild(numberBox);
                item.appendChild(colorBox);
                item.appendChild(text);

                legendDiv.appendChild(item);
            });
        }


          // Inizializzazione
          loadSavedData();
          createCharts1();
          createCharts2();
          createCharts3();
          createLithologyPlot('lito_cptm');
          createunitPlot('utcptm');
          createLithologyLegend('lithology-legend', dict_plt);


          document.getElementById('committente').addEventListener('input', saveData);
          document.getElementById('localita').addEventListener('input', saveData);
          document.getElementById('via').addEventListener('input', saveData);
          document.getElementById('nome').addEventListener('input', saveData);

        </script>
      </body>
    </html>
  `);

  reportWindow.document.close();
};